import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Copy, CopySplit } from '../../stateless/copy';
import { AnswersTextRadio } from '../../stateless/answers';
import { NextButton } from '../../stateless/buttons';
import HOCNextStepController from '../../hoc/next-step-controller';

const EnhancedButton = HOCNextStepController(NextButton);

export default class SituationalJudgement extends Component {

	static PropTypes = {
		user: PropTypes.object,
		players: PropTypes.object,
		window: PropTypes.object,
		nextWindow: PropTypes.func,
		countryCode: PropTypes.string
	};

	buildCopyType () {
		let copyComponent;
		const copySettings = {
			user: this.props.user,
			window: this.props.window,
			countryCode: this.props.countryCode,
			players: this.props.players
		};

		if (this.props.window.current.answers) {
			copyComponent = (
				<CopySplit {...copySettings}>
					<AnswersTextRadio
						answers={this.props.window.current.answers}
						updateAnswer={this.props.updateAnswer}
						currentValue={this.props.currentValue}
						countryCode={this.props.countryCode}
					/>
					<EnhancedButton
						{ ...this.props }
					/>
				</CopySplit>
			)
		} else {
			copyComponent = (
				<Copy {...copySettings}>
					<EnhancedButton
						{ ...this.props }
					/>
				</Copy>
			)
		}

		return copyComponent;
	}

	/**
	 * @description
	 * Component Method
	 * Renders a component
	 *
	 * @returns {ReactElement} component
	 */
	render () {
		return (
			<div>
				{this.buildCopyType()}
			</div>
		)
	}
}
